<template>
    <div>
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>{{ header }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark depressed :to="{ name: 'videos.add' }" >Add Video</v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-data-table :headers="headers" :loading="loading" :items="videos" item-key="name" :pagination.sync="pagination" :rows-per-page-items="rowsPerPageItems" :total-items="totalVideo">
                <template slot="items" slot-scope="props">
                    <tr>
                        <td width="40">{{ props.item.id }}</td>
                        <td width="50%">{{ props.item.title }}</td>
                        <td width="40">{{ props.item.category }}</td>
                        <td>
                            <v-chip v-for="i in props.item.tags" small :key="i['slug']">{{ i['name'] }}</v-chip>
                            <i>{{ props.item.tags.length == 0 ? 'No Tags' : '' }}</i>
                        </td>
                        <td align="right">
                            <v-btn flat icon class="ma-0" @click="handleEdit(props.item)" >
                                <v-icon small>edit</v-icon>
                            </v-btn>
                            <v-btn flat icon color="red darken-1"  class="ma-0" @click="handleDelete( props.item.id , props.item.name )">
                                <v-icon small>delete</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>

        <v-dialog
                persistent
                scrollable
                v-model="dialog"
                width="500"
        >
            <v-card>
                <v-card>
                    <div>
                        <v-toolbar flat color="white">
                            <v-toolbar-title>Edit Video Details</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-divider></v-divider>
                    </div>
                    <div>
                        <v-container fluid>
                            <v-layout row>
                                <v-flex xs12 >
                                    <v-text-field
                                            label="Title"
                                            light
                                            name="title"
                                            :autofocus="true"
                                            v-model="edit_title"
                                            placeholder="Edit Title "
                                            v-validate="'required'"
                                            :success="!errors.first('name')"
                                            :error-messages="errors.first('name')"
                                    >
                                    </v-text-field>
                                    <v-textarea
                                            label="Description"
                                            light
                                            name="description"
                                            v-model="edit_description"
                                            placeholder="Edit video description"
                                            v-validate="'required'"
                                            :success="!errors.first('description')"
                                            :error-messages="errors.first('description')"
                                    ></v-textarea>
                                    <div>
                                        <h3 v-html="translatedText"></h3>
                                    </div>
                                    <v-select
                                            :items="filters"
                                            name="category"
                                            label="Playlist"
                                            v-model="edit_category"
                                           placeholder="Please select video playlist"
                                            :rules="categoryRule"
                                            :success="model.category"
                                    ></v-select>
                                    <v-combobox
                                            :items="filters_tags"
                                            name="tags"
                                            label="Tags"
                                            v-model="edit_tags"
                                            placeholder="Please add video tags"
                                            multiple
                                            persistent-hint
                                            small-chips
                                            v-validate="'required'"
                                            :success="!errors.first('tags')"
                                            :error-messages="errors.first('tags')"
                                    >
                                    <template slot="no-data">
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-title>
                                                    No results matching "
                                                    <strong>{{ search }}</strong>". Press
                                                    <kbd>enter</kbd> to create a new one
                                                </v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </template>
                                    </v-combobox>
                                    <v-checkbox
                                            v-model="edit_downloadable"
                                            label="Enable download"
                                            color="primary"
                                    ></v-checkbox>

                                    <h4 class="grey--text lighten-1 mb-2" v-if="thumbUrl ==''">Uploaded video</h4>
                                    <img :src="thumbUrlOriginal" v-if="thumbUrl ==''" width="200">
                                    <h4 class="grey--text darken-3 mb-2" v-if="thumbUrl ==''">{{ original_name }}</h4>


                                    <h4 class="grey--text lighten-1 mb-2" v-if="thumbUrl ==''">Upload your video to change video</h4>
                                    <div>
                                        <v-btn class="fileContainer" v-if="thumbUrl ==''">
                                            <input
                                                    type="file"
                                                    id="file"
                                                    ref="file"
                                                    style="opacity: 0; width: 0; height: 0;"
                                                    accept="video/*"
                                                    v-on:change="handleFileUpload()"
                                            >
                                            Select video file
                                        </v-btn>

                                        <v-btn class="fileContainer" v-if="this.videoId !== undefined">
                                            <input
                                                  type="file"
                                                  id="subtitleFile"
                                                  ref="subtitleFile"
                                                  style="opacity: 0; width: 0; height: 0;"
                                                  accept=".srt"
                                                  v-on:change="handleSubtitleFileUpload()"
                                            >
                                            Select Subtitle File
                                        </v-btn>


                                    <v-progress-linear
                                            v-model="progress"
                                            v-if="progress"
                                            :indeterminate="indeterminate"
                                    ></v-progress-linear>
                                    <p v-if="progress">{{ displayLoadedSize }}/{{ displayTotalSize }}</p>
                                    <v-alert :value="true" type="success" v-if="thumbUrl" outline class="processing">
                                        <b>Status: Uploaded and Processing...</b>
                                        <br>The video has been uploaded. You can publish video now. It will be available as soon as processed.
                                        <br>Processing video might take 10-25 minutes depending on the size of video.
                                    </v-alert>

                                    <v-alert :value="true" type="error" v-if="uploadError" outline class="processing">
                                        <b>Status: Failed!</b>
                                        <br>The video file you have uploaded is in invalid format. Please select upload another file.
                                    </v-alert>

                                    <v-btn
                                            depressed
                                            v-if="thumbUrl"
                                            color="red"
                                            v-on:click="reset()"
                                            class="ml-0 white--text"
                                            flat
                                    >Remove video
                                    </v-btn>

                                    <div class="mt-2">
                                        <h4 class="grey--text lighten-1 mb-2">Video thumbnail</h4>
                                        <p v-if="!thumbUrl">Please upload video first.</p>
                                        <img :src="thumbUrl" v-if="thumbUrl" width="200">
                                    </div>
                                    </div>

                                </v-flex>

                            </v-layout>
                        </v-container>
                    </div>
                     <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue " flat @click="dialog = false">Close</v-btn>
                        <v-btn color="primary" depressed pull-right  @click="handleChange()">Submit</v-btn>
                    </v-card-actions>
                    <v-spacer></v-spacer>
                </v-card>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
  import Create from '~/pages/videos/create.vue'
  import Axios from 'axios';

  export default {
    props: {
      inProgressVideos: {
        type: Boolean,
        default: false,
      }
    },
    components: {
      'edit-box' : Create
    },
    data() {
      return {
        url: '/api/v1/videos',
        header: "Videos",
        dialog: false,
        edit_name: '',
        edit_title:'',
        edit_tags :'',
        edit_description : '',
        edit_category : '',
        edit_downloadable:'',
        thumbUrlOriginal: '',
        original_name: '',
        skip: 0,
        next: 0,
        prev: 0,
        perPage: 10,
        pagination: {
          rowsPerPage: 10
        },
        headers: [
          { text: "ID", value:'id', sortable:true,  },
//          { text: "Thumb", value: "thumb_url", sortable:false },
          { text: "Title", value: "title", sortable:true },
          { text: "Playlist", value: "category", sortable:false },
          { text: "Tags", value: "tags", sortable:false },
          { text: "Action", value: "action", sortable:false, align:"center"  }
        ],
        items: [],
        filters_tags : this.tagitems(),
        categoryRule: [ v => !!v || 'Playlist is required' ],
        totalVideo: 0,
        videos: [],
        loading: false,
        rowsPerPageItems: [5, 10, 25, 50],
        removeUrl: "/api/videos/remove",
        submitUrl: "/api/videos",
        translatedText: '',
        progress: 0,
        displayLoadedSize: 0,
        displayTotalSize: 0,
        indeterminate: false,
        file: "",
        search: "",
        fileSize: 2147483648,
        uploadFileUrl: "",
        thumbUrl: "",
        model: {
          title: "",
          description: "",
          category: "",
          downloadable: true,
          tags: [],
          video: {},
          subtitlePath: '',
        },
        uploadError: false,
        submitting: false,
        filters: this.categoryitems(),
      };
    },
    watch: {
      pagination: {
        handler (newVal, oldVal) {
          this.skip = (newVal.page - 1) * newVal.rowsPerPage || 0;

          if(newVal.rowsPerPage !== this.perPage){
            this.perPage = newVal.rowsPerPage;
            this.skip = 0;
          }

          this.getVideos()
        },
        deep: true
      },
      $route (to, from){
        console.log(to, from);
        this.getVideos()
      }
    },
    methods: {
      handleFileUpload() {
        this.uploadError = false;
        this.file = this.$refs.file.files[0];
        this.startUpload();
      },
      handleSubtitleFileUpload() {
        this.subtitleUploadError = false;
        this.subtitleFile = this.$refs.subtitleFile.files[0];
        this.startSubtitleUpload();    
      },
      getUrl(){
        const direction = this.pagination.descending ? 'asc' : 'desc';
        const sort = this.pagination.sortBy || 'id';
        if (this.inProgressVideos){
          return `${this.url}?limit=${this.perPage}&skip=${this.skip}&sort=${sort}&by=${direction}&inProgress=true`;
        }
        return `${this.url}?limit=${this.perPage}&skip=${this.skip}&sort=${sort}&by=${direction}`;
      },
      async getVideos(){
        this.videos= new Array();
        this.loading = !this.loading;
        const response = await Axios.get(this.getUrl());
        console.log(response, this.getUrl());
        this.videos = response.data.data;
        this.totalVideo = response.data.meta.cursor['count'];
        this.next = response.data.meta.cursor['next'];
        this.prev = response.data.meta.cursor['prev'];
        this.loading = !this.loading;
     },
      async handleDelete (id) {
        var r = confirm("Are you sure want delete video " + id);
        if (r == true) {
           await Axios.delete('/api/v1/videos/' + id).then((response) => {
            console.log(response);
            this.getVideos();
          })
        }
       

      },
      categoryitems(){
        Axios.get('/videos/categoryitem').then( response => {
          this.filters=Object.values(response.data);
        } ).catch((error) => {
          this.success = false;
        });
      },
      tagitems(){
        Axios.get('/videos/tagitem').then( response => {
          this.filters_tags = Object.values(response.data);
        } ).catch((error) => {
          this.success = false;
        });
      },
      async handleEdit (item){

        var id = item.id;
        var title = item.title;
        var description = item.description;
        var edit_downloadable = item.downloadable;
        var edit_category = item.category;
        var edit_tags = item.tags;

        var abcd =[];
        for(var i=0;i<Object.values(edit_tags).length;i++){
             var abc =JSON.stringify(Object.values(edit_tags)[i].name);
            abc= abc.replace(/\"/g, "")
             abcd.push(abc);
        }


        this.dialog=true;
        this.edit_title=title;
        this.edit_description=description;
        this.edit_downloadable = edit_downloadable
        this.index_num=id;
        this.edit_tags=abcd;
        this.edit_category=edit_category;
        this.thumbUrlOriginal = item.thumb_url;
        this.original_name = item.original_name;

      },

      async reset() {
        this.progress = 0;
        this.thumbUrl = "";
        this.file = null;
        try {
          Axios.post(this.removeUrl, {video: this.model.video});
          this.model.video = null;
        } catch (err) {
          this.thumbUrl = this.model.video["thumbnail"];
        }
      },
      async handleChange(){
        console.log("Edit Downloadable", this.edit_downloadable);

        await Axios.put('videos/update/' + this.index_num , {"data":
            {
              "id": this.index_num,
              "title": this.edit_title,
              "description" : this.edit_description,
              "tags": this.edit_tags,
              "category":this.edit_category,
              "downloadable": this.edit_downloadable,
              "video": this.model.video
            }
        })
          .then((response) => {

          console.log(response);
          this.getVideos();
          this.progress = 0;
          this.thumbUrl = "";
          this.file = null;
          this.dialog=false;
        })

      },
      startUpload() {
        let formData = new FormData();
        formData.append("file", this.file);

        const config = {
          onUploadProgress: this.onProgress,
          headers: {
            "Content-Type": "multipart/form-data"
          }
        };

        Axios.post('/api/videos/upload', formData, config)
          .then(response => {
            this.progress = 0;
            this.thumbUrl = response.data["thumbnail"];
            this.videoId = response.data["videoId"];
            this.model.video = response.data;
          })
          .catch(error => {
            console.log(error.response);
            this.uploadError = true;
          });
      },
      startSubtitleUpload() {
        let formData = new FormData();
        formData.append("subtitleFile", this.subtitleFile);
        formData.append("videoId", this.videoId);
        const config = {
          onUploadProgress: this.onProgress,
          headers: {
            "Content-Type": "multipart/form-data"
          }
        };

        Axios.post('/api/videos/uploadSubtitle', formData, config)
          .then(response => {
            this.model.subtitlePath = response.data.subtitlePath
          })
          .catch(error => {
            console.log(error.response);
            this.subtitleUploadError = true;
          });
      },
    }
  };
</script>

<style>
    .dropzone-custom-content {
        text-align: center;
    }

    .dropzone-custom-title {
        margin-top: 0;
        color: #1078d5;
    }

    .subtitle {
        color: #314b5f;
    }

    .fileContainer {
        margin: 0 0 10px 0;
    }

    .fileContainer [type="file"] {
        cursor: inherit;
        display: block;
        filter: alpha(opacity=0);
        min-height: 100%;
        min-width: 100%;
        opacity: 0;
        position: absolute;
        right: 0;
        text-align: right;
        top: 0;
    }

    .font-select {
        width: 150px
    }

    .ve-select span {
        font-size: 14px;
    }

    .ve-select {
        min-width: 75px;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/videos/index.vue